import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, Award, Users, Briefcase, Target, CheckCircle2 } from 'lucide-react';

const BestExpertsSection = ({ onOpenContactForm }) => {
  return (
    <section className="py-24 bg-white" data-testid="best-experts-section">
      <div className="container mx-auto px-6 lg:px-16">
        <div className="grid lg:grid-cols-2 gap-16 items-stretch">
          <div className="rounded-lg overflow-hidden order-2 lg:order-1">
            <img src="https://images.unsplash.com/photo-1767786330387-5cef0327b6c1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjBsYXd5ZXIlMjB0ZWFtJTIwb2ZmaWNlJTIwbW9kZXJufGVufDB8fHx8MTc3NTUwNzUwMHww&ixlib=rb-4.1.0&q=85" alt="Expert trademark attorneys" className="w-full h-full object-cover" data-testid="experts-image" />
          </div>
          <div className="order-1 lg:order-2 space-y-6">
            <p className="text-xs uppercase tracking-[0.2em] font-bold text-zinc-500">Our Team</p>
            <h2 className="text-2xl sm:text-3xl font-bold tracking-tight text-[#09090B]" style={{fontFamily:'Outfit,sans-serif'}} data-testid="experts-heading">
              Trademark Attorneys Who Deliver Results
            </h2>
            <p className="text-sm leading-relaxed text-zinc-600">
              Our legal team specializes in federal trademark registration, USPTO filing, and brand protection strategy. From startups to enterprise brands, we have the experience to get your mark registered and defended.
            </p>
            <div className="grid grid-cols-2 gap-4">
              {[
                { icon: Award, title: 'USPTO Specialists', desc: 'Deep filing expertise' },
                { icon: Users, title: 'Nationwide Clients', desc: 'All 50 states served' },
                { icon: Briefcase, title: 'Every Industry', desc: 'Full sector coverage' },
                { icon: Target, title: 'Strategic Advisors', desc: 'Growth-oriented counsel' },
              ].map(({ icon: Icon, title, desc }) => (
                <div key={title} className="card-hover bg-[#F4F4F5] rounded-lg p-4">
                  <Icon className="w-5 h-5 text-[#002FA7] mb-2" />
                  <h4 className="text-sm font-semibold text-[#09090B]">{title}</h4>
                  <p className="text-xs text-zinc-500">{desc}</p>
                </div>
              ))}
            </div>
            <div className="space-y-2.5">
              {['Dedicated case manager for every client', 'Real-time status updates and direct access', 'Proactive monitoring and infringement defense'].map((text) => (
                <div key={text} className="flex items-start gap-2">
                  <CheckCircle2 className="w-4 h-4 text-[#002FA7] mt-0.5 flex-shrink-0" />
                  <p className="text-sm text-zinc-600">{text}</p>
                </div>
              ))}
            </div>
            <Button onClick={onOpenContactForm} className="btn-lift bg-[#002FA7] hover:bg-[#001D66] text-white px-6 py-5 font-semibold rounded-md" data-testid="experts-cta">
              Talk to an Attorney <ArrowRight className="ml-2 w-4 h-4" />
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BestExpertsSection;
